<template>
  <div>
    <ContenedorCollapsable
      idCollapsable="matriculacion"
      tituloColapsable="¿Cuántas personas se matriculan y qué rendimiento tienen en enseñanza media?"
    >
      <div
        class="kpis col-12 col-md-10 mx-md-auto mt-2 px-0 border-bottom-azul"
      >
        <h3 class="subtt text-azul-medio w-100 text-center mt-3 mb-2">
          matrícula
        </h3>

        <div class="d-md-flex">
          <div class="col-md-5 sel1">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">{{ carrera1.carreraGenerica }}</h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">1º año:</dt>
                  <dd class="cont col">
                    {{ formatoNumerico(carrera1.matriculaTotalPrimerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">Total:</dt>
                  <dd class="cont col">
                    {{ formatoNumerico(carrera1.matriculaTotal) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">Promedio<br />NEM:</dt>
                  <dd :class="reducirPadding(carrera1.promedioNEM)">
                    {{ textoPromedioNem(carrera1.promedioNEM) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-2 icos text-center px-2">
            <img
              class="small-ic align-self-center"
              src="@/assets/img/iconos/comparador-3.svg"
              alt="documento"
            />
          </div>
          <hr class="mt-0 d-block d-md-none" />

          <div class="col-md-5 sel2">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">
                {{ carrera2.carreraGenerica }}
              </h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">1º año:</dt>
                  <dd class="cont col">
                    {{ formatoNumerico(carrera2.matriculaTotalPrimerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">Total:</dt>
                  <dd class="cont col">
                    {{ formatoNumerico(carrera2.matriculaTotal) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">Promedio<br />NEM:</dt>
                  <dd :class="reducirPadding(carrera2.promedioNEM)">
                    {{ textoPromedioNem(carrera2.promedioNEM) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="kpis col-12 col-md-10 mx-auto mt-2 mb-3">
        <h3 class="subtt text-azul-medio w-100 text-center mt-3 mb-2">
          porcentaje de<br />estudiantes por sexo
        </h3>

        <div class="d-md-flex">
          <div class="col-md-5 sel1">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">{{ carrera1.carreraGenerica }}</h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">Hombres:</dt>
                  <dd class="cont col">
                    {{ carrera1.porcentajeMatriculaTotalMasculino }}%
                  </dd>
                </li>
                <li>
                  <dt class="label col">Mujeres:</dt>
                  <dd class="cont col">
                    {{ carrera1.porcentajeMatriculaTotalFemenino }}%
                  </dd>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-2 icos text-center px-2">
            <img
              class="small-ic align-self-center"
              src="@/assets/img/iconos/comparador-4.svg"
              alt="usuarios"
            />
          </div>
          <hr class="mt-0 d-block d-md-none" />

          <div class="col-md-5 sel2">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">
                {{ carrera2.carreraGenerica }}
              </h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">Hombres:</dt>
                  <dd class="cont col">
                    {{ carrera2.porcentajeMatriculaTotalMasculino }}%
                  </dd>
                </li>
                <li>
                  <dt class="label col">Mujeres:</dt>
                  <dd class="cont col">
                    {{ carrera2.porcentajeMatriculaTotalFemenino }}%
                  </dd>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ContenedorCollapsable>
  </div>
</template>

<script>
import ContenedorCollapsable from "@/components/comparadorITP/ContenedorCollapsable";
import FormatoMonetario from "@/utils/FormatoMonetario.js";

export default {
  name: "MatriculacionRendimientoCollapse",
  components: {
    ContenedorCollapsable
  },
  props: {
    carrera1: { type: Object },
    carrera2: { type: Object }
  },
  methods: {
    formatoNumerico(value) {
      return FormatoMonetario.getFormatoNumerico(value);
    },
    textoPromedioNem(valor) {
      return valor != 0 ? valor : "SIN INFORMACIÓN DISPONIBLE";
    },
    reducirPadding(valor) {
      return valor != 0 ? "cont col" : "cont";
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/comparadorITP/MatriculacionRendimientoCollapse.vue